(function(){
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function start(v){
    if (v.dataset.src && !v.getAttribute('src')) { v.setAttribute('src', v.dataset.src); }
    if (reduce) return;
    var p = v.play();
    if (p && p.catch) p.catch(function(){});
  }
  function init(root){
    var els = (root || document).querySelectorAll('video.mm-vloop:not([data-tt])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function(v){ v.dataset.tt = '1'; start(v); }); return; }
    var io = window.__ttLoopIO || (window.__ttLoopIO = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if (e.isIntersecting) { start(e.target); } else if (!e.target.paused) { e.target.pause(); } });
    }, { rootMargin: '250px 0px' }));
    els.forEach(function(v){ v.dataset.tt = '1'; io.observe(v); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function(){ init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
